module.exports = __webpack_public_path__ + "img/1stgroup.6b9abc00.png";